import React from 'react';
import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('distributionConfiguration');

interface IDistributionConfigurationProps {
  inheritedProps?: any;
}

const distributionConfiguration = (props: IDistributionConfigurationProps) => {
  return <GlobalDataGrid configComponent={defaultConfigComponent} inheritedProps={props.inheritedProps} />;
};

export default distributionConfiguration;
